import React, { useState } from 'react';
import { apiPost } from '../../api';
import { toast } from 'react-toastify';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const EditUser = () => {
  const { username } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Parse query parameters
  const queryParams = new URLSearchParams(location.search);
  const [form, setForm] = useState({
    name: decodeURIComponent(queryParams.get('name') || ''),
    surname: decodeURIComponent(queryParams.get('surname') || ''),
    email: decodeURIComponent(queryParams.get('email') || ''),
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await apiPost(`/api/admin/user/${username}/edit`, { ...form, username: username });
      if (res.data.success) {
        toast.success('User updated successfully');
        setTimeout(() => navigate('/users'), 1200);
      } else {
        toast.error(res.data.message || 'Failed to update user');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error updating user');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Management
      </div>
      <div className="flex items-center gap-3 mb-1">
        <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground">Edit <span className="text-gradient-ginox">User</span></h1>
        <button
          onClick={() => navigate('/users')}
          className="rounded-md border border-border/70 bg-white/[0.02] px-3 py-1.5 text-xs text-muted-foreground hover:bg-white/[0.05] hover:text-foreground transition-colors flex items-center gap-1.5 self-end mb-2"
        >
          <ArrowLeft className="w-3 h-3" />
          Back
        </button>
      </div>
      <p className="text-sm text-muted-foreground mb-6 ml-0">
        Editing <span className="font-mono text-foreground">#{username}</span>
      </p>

      <div className="border-t border-white/[0.08] pt-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Name
            </label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="First name"
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
            />
          </div>

          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Surname
            </label>
            <input
              name="surname"
              value={form.surname}
              onChange={handleChange}
              placeholder="Last name"
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
            />
          </div>

          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Email
            </label>
            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="user@example.com"
              type="email"
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
            />
          </div>

          <div className="flex items-center gap-3 pt-2">
            <button
              type="submit"
              disabled={loading}
              className="rounded-md border border-ginox-green/60 bg-ginox-green/10 px-4 py-2 text-xs font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-50"
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/users')}
              className="rounded-md border border-border/70 bg-white/[0.02] px-4 py-2 text-xs text-muted-foreground hover:bg-white/[0.05] hover:text-foreground transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUser;
